import styled, { useTheme } from 'styled-components'
import BottomSheetLayout from './common/BottomSheetLayout'
import Text from '../atoms/Text'
import SelectableChip from '../atoms/SelectableChip'
import MainButton from '../atoms/MainButton'

const Header = styled.div`
  margin-bottom: 16px;
`
const SampleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`
const DescriptionList = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 16px;
  margin-top: 16px;
`

const ItemTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`
const CircleChip = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({ $colors }) => $colors.bg};
  border: 1px solid ${({ $colors }) => $colors.border};
`
const ButtonWrapper = styled.div`
  margin-top: 16px;
`
const RecommendWordGuideSheet = ({ $isOpen, onClose }) => {
  const CONTENTS = [
    {
      id: 1,
      rate: 1, 
      title: '유사도 높음',
      description: '아이의 발음과 등록된 단어가 거의 일치해요.',
      label: '바나나'
    },
    {
      id: 2,
      rate: 0.56, 
      title: '유사도 보통',
      description: '발음을 고려할 때 이 의미일 가능성이 높아요.',
      label: '토끼'
    },
    {
      id: 3,
      rate: 0, 
      title: '유사도 낮음',
      description: '비슷한 단어가 없거나 처음 등장한 발음이에요.  ',
      label: '게임'
    }
  ]

  const theme = useTheme();

  // 여기서는 text 필요없음
  const getColor = (rate, theme) => {
    if (rate >= 0.7) {
      return {
        bg: '#EAF3FE',
        border: theme.colors.status.info,
        text: 'info'
      };
    }
    if (rate >= 0.56) {
      return {
        bg: '#F2FAF6',
        border: theme.colors.status.success,
        text: 'success'
      };
    }
    return {
      bg: '#FEF9E9',
      border: theme.colors.status.warning,
      text: 'warning'
    };
  };

  return (
    <BottomSheetLayout $isOpen={$isOpen} onClose={onClose}>
      <Header>
        <Text variant="headline3" weight="medium">추천 단어</Text>
      </Header>
      <>
        <SampleWrapper>
          {CONTENTS.map((item) => (
            <SelectableChip
              key={item.id}
              label={item.label}
              rate={item.rate}
              cursor="default"
            />
          ))}
        </SampleWrapper>
        <DescriptionList>
          {CONTENTS.map((item) => {
            const colors = getColor(item.rate, theme);

            return (
              <div key={item.id}>
                <ItemTitle>
                  <CircleChip $colors={colors}/>
                  <Text variant="body1">{item.title}</Text>
                </ItemTitle>
                <Text variant="body2" color="alternative">
                  {item.description}
                </Text>
              </div>
            );
          })}
        </DescriptionList>
        <ButtonWrapper>
          <MainButton 
            $variant="primary" 
            title="확인" 
            onClick={onClose}/>
        </ButtonWrapper>
      </>
    </BottomSheetLayout>
  )
}

export default RecommendWordGuideSheet
